import { prop } from 'ramda';
import { axios as $axios } from './../utils/axios.js';
import { urls } from './../config.js';
import { tokenInterceptor } from '../utils/axios-interceptors';
export function authClient(clientId, clientSecret) {
  var data = {
    client_id: clientId,
    client_secret: clientSecret,
    grant_type: 'client_credentials'
  };
  return $axios({
    autoAuth: false
  }).then(function (api) {
    return api.post(urls.api('/oauth/token'), data);
  }).then(prop('data')).then(prop('access_token'));
}
export function authPassword(username, password) {
  var data = {
    grant_type: 'password',
    username: username,
    password: password
  };
  return $axios({
    autoAuth: false
  }).then(function (api) {
    api.interceptors.request.use(tokenInterceptor);
    return api.post(urls.api('/oauth/token'), data);
  }).then(prop('data'));
}
export function authSSO(identityProvider, code) {
  var data = {
    grant_type: 'sso',
    identityProvider: identityProvider,
    code: code
  };
  return $axios({
    autoAuth: false
  }).then(function (api) {
    api.interceptors.request.use(tokenInterceptor);
    return api.post(urls.api('/oauth/token'), data);
  });
}